export default __webpack_public_path__ + "static/media/google-drive.45b56cf7.svg";